'use client';

import React, { useState } from 'react';

const FinalCTA: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    /* Backend integration point: POST { email } to newsletter API */
    setSubmitted(true);
  };

  return (
    <section
      className="py-20 md:py-28 px-6 text-center reveal"
      style={{
        background: 'linear-gradient(160deg, #F5F0E8 0%, #EDE6D6 100%)',
        borderTop: '1px solid var(--color-cream-border)',
      }}
    >
      <div className="max-w-2xl mx-auto">
        {/* Decorative rule */}
        <div className="flex items-center gap-4 mb-10">
          <div className="flex-1 h-px" style={{ background: 'var(--color-cream-border)' }} />
          <span
            className="font-display italic text-sm"
            style={{ color: 'var(--color-charcoal-light)' }}
          >
            This archive is too rich to track alone.
          </span>
          <div className="flex-1 h-px" style={{ background: 'var(--color-cream-border)' }} />
        </div>

        <h2
          className="font-display font-black leading-tight mb-4"
          style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            color: 'var(--color-charcoal)',
            letterSpacing: '-0.02em',
          }}
        >
          147 Episodes.
          <br />
          <span style={{ color: 'var(--color-brass)' }}>One weekly email.</span>
        </h2>

        <p
          className="font-body text-base leading-relaxed mb-8"
          style={{ color: 'var(--color-charcoal-light)' }}
        >
          Timestamped highlights, guest links, and one behind-the-scenes
          production note per episode. Join 4,200+ independent creators
          who already get the Rundown.
        </p>

        {/* Stats row */}
        <div className="flex items-center justify-center gap-8 mb-10">
          {[
            { value: '147', label: 'Episodes' },
            { value: '4.2k', label: 'Subscribers' },
            { value: '6 yrs', label: 'Running' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p
                className="font-display font-black text-2xl"
                style={{ color: 'var(--color-charcoal)' }}
              >
                {stat.value}
              </p>
              <p
                className="section-label mt-1"
                style={{ color: 'var(--color-charcoal-light)' }}
              >
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {!submitted ? (
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              required
              className="flex-1 px-4 py-3 rounded-sm text-sm font-body"
              style={{
                background: 'rgba(59,58,54,0.06)',
                border: '1px solid rgba(59,58,54,0.2)',
                color: 'var(--color-charcoal)',
              }}
            />
            <button
              type="submit"
              className="btn-brass px-6 py-3 rounded-sm text-sm flex-shrink-0"
            >
              Get the Rundown →
            </button>
          </form>
        ) : (
          <div
            className="py-5 px-6 rounded-sm"
            style={{
              background: 'rgba(184,160,74,0.1)',
              border: '1px solid rgba(184,160,74,0.3)',
            }}
          >
            <p
              className="font-display italic font-semibold text-lg"
              style={{ color: 'var(--color-brass-dark)' }}
            >
              ✓ You're subscribed. First Rundown arrives Monday.
            </p>
          </div>
        )}

        {/* Secondary YouTube CTA */}
        <div className="mt-6 flex items-center justify-center gap-3">
          <span
            className="font-body text-sm"
            style={{ color: 'var(--color-charcoal-light)' }}
          >
            Not ready to commit?
          </span>
          <a
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-body text-sm font-semibold underline underline-offset-2 transition-colors"
            style={{ color: 'var(--color-brass)' }}
          >
            Subscribe on YouTube →
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;